class RemoveEmptyStringService {
  remove(value?: string): string | undefined {
    return value ? value.trim() : undefined;
  }
}

export default RemoveEmptyStringService;
